<template>
  <div>
    <el-row style="text-align: left;font-size: 16px;margin-left: 5%">
      <el-col :span="5">
        <span>线别：{{ lineData.line_name }}</span>
      </el-col>
      <el-col :span="5">
        <span>{{ $t('makeSchedule.mfgAssemblyReportDetail.personResponsible') }}：{{ lineData.line_leader_name }}</span>
      </el-col>
      <el-col :span="5">
        <span>{{ $t('makeSchedule.mfgAssemblyReportDetail.totalArea') }}：{{ lineData.total_area }}</span>
      </el-col>
      <el-col :span="4">
        <span>人工：{{ lineData.zj_total_man_hour }}</span>
      </el-col>
      <el-col :span="5">
        <span>生产性：{{ lineData.productive }}</span>
      </el-col>

      <el-col :span="24">
        <span>备注：{{ lineData.remark }}</span>
      </el-col>
    </el-row>
    <div style="margin-top: 10px">
<!--      <FrameTab component-param="mfg_assembly_report_form_tab" :parent-data="parentData"/>-->
      <el-tabs type="border-card" @tab-click="getLineData" v-model="activeName">
        <el-tab-pane v-for="line in lineAll" :key="line.id" :label="lineName[line.idx]" :name="'line_'+line.idx">
          <MfgAssemblyReportLine :activeName="'line_'+line.idx" :productionDate="fromData.production_date"></MfgAssemblyReportLine>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import MfgAssemblyReportLine from "@/views/applications/bus/make_schedule/MfgAssemblyReportLine";
export default {
  name: "MfgAssemblyReportDetail",
  components: { MfgAssemblyReportLine },
  props: {
    setting: {
      type: Object,
      default: () => {
        return {}
      }
    },
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data(){
    return {
      fromData: this.parentData,
      lineData:{},
      lineName:{1:"线一",2:"线二",3:"线三",4:"线四",5:"线五",6:"线六",7:"线七",8:"线八",9:"外线"},
      lineAll:[],
      activeName:'line_1',
    }
  },methods: {
    getLineData(tab) {
      if (tab) {
        this.fromData.activeName = tab.props.name
      } else {
        this.fromData.activeName = this.activeName
      }

      this.$axios.post('mfg/lineData/getLineData',this.fromData).then(response => {
        let res = response.data
        if (res.code !== 0) {
          return this.$message.error(res.message)
        }

        this.lineData = res.data
      }, error => {
        this.$message.error(`获取数据失败` + error.message);
      })
    },
    getLineAll() {
      this.$axios.get('mfg/lineData/getLineAll').then(response => {
        let res = response.data
        if (res.code !== 0) {
          return this.$message.error(res.message)
        }

        this.lineAll = res.data
      }, error => {
        this.$message.error(`获取数据失败` + error.message);
      })
    }
  },created() {
    this.getLineAll()
    this.getLineData()
  }
}
</script>

<style scoped>

</style>